import PropTypes from 'prop-types';
import ExtraPropTypes from 'react-extra-prop-types';

export default PropTypes.shape({
  uuid: ExtraPropTypes.uuid.isRequired,
  name: PropTypes.string,
  desc: PropTypes.string,
  image: PropTypes.string,
  year: PropTypes.number,
});
